import React from 'react'

function ExpandSmPlusIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 2.5C0 1.11929 1.11929 0 2.5 0H7.5C8.88071 0 10 1.11929 10 2.5V7.5C10 8.88071 8.88071 10 7.5 10H2.5C1.11929 10 0 8.88071 0 7.5V2.5ZM2.5 1C1.67157 1 1 1.67157 1 2.5V7.5C1 8.32843 1.67157 9 2.5 9H7.5C8.32843 9 9 8.32843 9 7.5V2.5C9 1.67157 8.32843 1 7.5 1H2.5Z" fill="black"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 5.00122C2.5 4.72508 2.72386 4.50122 3 4.50122H7C7.27614 4.50122 7.5 4.72508 7.5 5.00122C7.5 5.27736 7.27614 5.50122 7 5.50122H3C2.72386 5.50122 2.5 5.27736 2.5 5.00122Z" fill="black"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.00119 7.5C4.72505 7.5 4.50119 7.27614 4.50119 7L4.50119 3C4.50119 2.72386 4.72505 2.5 5.00119 2.5C5.27733 2.5 5.50119 2.72386 5.50119 3L5.50119 7C5.50119 7.27614 5.27733 7.5 5.00119 7.5Z" fill="black"/>
</svg>
  )
}

export default ExpandSmPlusIcon